import { AppState } from '../../AppState';

export const sharedState = new AppState();
